import page_sections from '@/configurations/pages'
import Columns from '@/classes/pages/Columns'
import { guid } from '@/utils/utils'

export default class Module {
  constructor ({ name = null, type = null, options = {}, style = {}, attributes = {} } = {}) {
    this.id = name + guid(2)
    this.name = name
    this.type = type
    this.options = options
    this.style = style
    this.attributes = attributes
  }

  get config () {
    return page_sections.find(section => new RegExp(`^${section.name}$`).test(this.name))
  }

  get path () {
    return this.config?.path || null
  }

  get is_visible () {
    return !('is_visible' in this.options) || this.options.is_visible === true
  }

  get custom_key () {
    return this.name.split('_').filter(key => !this.config?.name.includes(key)).join('_')
  }

  get columns () {
    return new Columns(this.attributes.columns || [])
  }
}
